/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_Notsupported1Inputs */

const id_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi push tidak didukung di browser ini.`)
};

const ms_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan push tidak disokong dalam pelayar ini.`)
};

const da_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-notifikationer understøttes ikke i denne browser.`)
};

const de_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-Benachrichtigungen werden in diesem Browser nicht unterstützt.`)
};

const en_us2_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push notifications are not supported in this browser.`)
};

const es_es2_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones push no son compatibles con este navegador.`)
};

const es_mx2_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones push no son compatibles con este navegador.`)
};

const fil_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi sinusuportahan ang push notifications sa browser na ito.`)
};

const fr_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications push ne sont pas prises en charge par ce navigateur.`)
};

const it_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le notifiche push non sono supportate in questo browser.`)
};

const hu_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A push értesítések nem támogatottak ebben a böngészőben.`)
};

const nl_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushmeldingen worden niet ondersteund in deze browser.`)
};

const no_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-varsler støttes ikke i denne nettleseren.`)
};

const pl_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia push nie są obsługiwane w tej przeglądarce.`)
};

const pt_br2_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push notifications are not supported in this browser.`)
};

const pt_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As notificações push não são suportadas neste navegador.`)
};

const ro_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificările push nu sunt suportate în acest browser.`)
};

const fi_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-ilmoituksia ei tueta tässä selaimessa.`)
};

const sv_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-notiser stöds inte i denna webbläsare.`)
};

const vi_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt này không hỗ trợ thông báo đẩy.`)
};

const tr_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push bildirimleri bu tarayıcıda desteklenmiyor.`)
};

const cs_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push oznámení nejsou v tomto prohlížeči podporována.`)
};

const bg_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push известията не се поддържат в този браузър.`)
};

const ru_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-уведомления не поддерживаются в этом браузере.`)
};

const uk_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-сповіщення не підтримуються в цьому браузері.`)
};

const ar_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات الفورية غير مدعومة في هذا المتصفح.`)
};

const hi_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुश सूचनाएँ इस ब्राउज़र में समर्थित नहीं हैं।`)
};

const th_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนแบบพุชไม่รองรับในเบราว์เซอร์นี้`)
};

const ja_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザはプッシュ通知をサポートしていません。`)
};

const zh_cn2_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push notifications are not supported in this browser.`)
};

const zh_hant1_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push notifications are not supported in this browser.`)
};

const ko_notifications_push_notsupported1 = /** @type {(inputs: Notifications_Push_Notsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 브라우저에서는 푸시 알림이 지원되지 않습니다.`)
};

/**
* | output |
* | --- |
* | "Push notifications are not supported in this browser." |
*
* @param {Notifications_Push_Notsupported1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_notsupported1 = /** @type {((inputs?: Notifications_Push_Notsupported1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_Notsupported1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_notsupported1(inputs)
	if (locale === "ms") return ms_notifications_push_notsupported1(inputs)
	if (locale === "da") return da_notifications_push_notsupported1(inputs)
	if (locale === "de") return de_notifications_push_notsupported1(inputs)
	if (locale === "en-US") return en_us2_notifications_push_notsupported1(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_notsupported1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_notsupported1(inputs)
	if (locale === "fil") return fil_notifications_push_notsupported1(inputs)
	if (locale === "fr") return fr_notifications_push_notsupported1(inputs)
	if (locale === "it") return it_notifications_push_notsupported1(inputs)
	if (locale === "hu") return hu_notifications_push_notsupported1(inputs)
	if (locale === "nl") return nl_notifications_push_notsupported1(inputs)
	if (locale === "no") return no_notifications_push_notsupported1(inputs)
	if (locale === "pl") return pl_notifications_push_notsupported1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_notsupported1(inputs)
	if (locale === "pt") return pt_notifications_push_notsupported1(inputs)
	if (locale === "ro") return ro_notifications_push_notsupported1(inputs)
	if (locale === "fi") return fi_notifications_push_notsupported1(inputs)
	if (locale === "sv") return sv_notifications_push_notsupported1(inputs)
	if (locale === "vi") return vi_notifications_push_notsupported1(inputs)
	if (locale === "tr") return tr_notifications_push_notsupported1(inputs)
	if (locale === "cs") return cs_notifications_push_notsupported1(inputs)
	if (locale === "bg") return bg_notifications_push_notsupported1(inputs)
	if (locale === "ru") return ru_notifications_push_notsupported1(inputs)
	if (locale === "uk") return uk_notifications_push_notsupported1(inputs)
	if (locale === "ar") return ar_notifications_push_notsupported1(inputs)
	if (locale === "hi") return hi_notifications_push_notsupported1(inputs)
	if (locale === "th") return th_notifications_push_notsupported1(inputs)
	if (locale === "ja") return ja_notifications_push_notsupported1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_notsupported1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_notsupported1(inputs)
	return ko_notifications_push_notsupported1(inputs)
});
export { notifications_push_notsupported1 as "notifications.push.notSupported" }